import React, { useState } from 'react';
import 'bootstrap';
import 'aos'
import '../assets/css/style.css';


const Faq = ({ product }) => {

    const [openDetails, setOpenDetails] = useState({
        open1: false,
        open2: false,
        open3: false,
        open4: false,
        open5: false,
    });

    const handleToggle = (key, e) => {
        e.preventDefault();
        
        setOpenDetails((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const faq_data = product==='LIMS' ? faqs_lims :  product==='ELN' ? faqs_eln :  product==='QMS' ? faqs_qms :  product==='DMS' ? faqs_dms : product==='ADBS' ? faqs_adbs : product==='T-LIMS' ? faqs_tlims : product==='LIMS-ELN' ? faqs_lims_eln : product==='LMS' ? faqs_lms : (product==='E-Logbook' || product==='ELOG') ? faqs_elog : product==='IPQC' ? faqs_ipqc : product==='VMS' ? faqs_vms : faqs_saas ;

    return (
        <React.Fragment>
            <div className="faq-div">
                <h1>{product} Frequently asked questions</h1>
                <ul>
                    {faq_data.map(({ key, question, answer }) => (
                        <li key={key}>
                            <details open={openDetails[key]}>
                                <summary onClick={(e) => handleToggle(key, e)}>
                                    <div className='faq-ques'>{question}</div>
                                    <div className="plus_to_minus_container">
                                        <div className={`plus_to_minus ${openDetails[key] ? "open" : ""}`}></div>
                                    </div>
                                </summary>
                                <p style={{fontSize:'16px'}}>{answer}</p>
                            </details>
                        </li>
                    ))}
                </ul>
            </div>
        </React.Fragment>
    )
}

export default Faq


const faqs_lims = [
    {
        key: "open1",
        question: "What is a LIMS and why is it used?",
        answer: `LIMS (Laboratory Information Management System) is a software solution that helps manage samples, lab workflows, test data, and compliance in laboratories.`,
    },
    {
        key: "open2",
        question: "Can LIMS integrate with lab instruments?",
        answer: `Yes, LIMS can be integrated with instruments like HPLC, GC, and balances for automated data capture and improved accuracy.`,
    },
    {
        key: "open3",
        question: "Is LIMS configurable to different industries like pharma, food, or biotech?",
        answer: `Absolutely. LIMS platforms are modular and can be configured to suit industry-specific workflows and regulations.`,
    },
    {
        key: "open4",
        question: "Does LIMS support multi-location or remote access?",
        answer: `Yes, cloud-based LIMS allows secure access across locations, ideal for organizations with multiple labs or remote teams.`,
    },
    {
        key: "open5",
        question: "Is LIMS compliant with regulatory standards?",
        answer: `Yes, most LIMS platforms are designed to comply with 21 CFR Part 11, ISO/IEC 17025, GLP, and other global regulations.`,
    },
];

const faqs_eln = [
    {
        key: "open1",
        question: "What is an ELN and how is it different from LIMS?",
        answer: `An ELN (Electronic Lab Notebook) is used to digitally capture, organize, and search scientific experiments and research notes. Unlike LIMS, which focuses on structured workflows and compliance, ELN is more flexible for R&D and documentation of exploratory work.`,
    },
    {
        key: "open2",
        question: "Can ELN capture raw data like images, graphs, and chemical structures?",
        answer: `Yes, ELNs support attachments including images, instrument outputs, Excel files, chemical drawing tools, and graphs for complete scientific documentation.`,
    },
    {
        key: "open3",
        question: "Is data in ELN secure and compliant with regulatory standards?",
        answer: `Absolutely. ELNs offer access control, audit trails, and electronic signatures to meet compliance standards like 21 CFR Part 11 and GLP.`,
    },
    {
        key: "open4",
        question: "Can ELNs be integrated with LIMS or instruments?",
        answer: `Yes, most ELNs offer APIs or integration options to sync with LIMS, CDS (Chromatography Data Systems), or directly with instruments.`,
    },
    {
        key: "open5",
        question: "Does ELN support collaboration and version tracking?",
        answer: `Yes, multiple users can collaborate on a single experiment, with automatic version history, time stamps, and comments for traceability.`,
    }
];

const faqs_qms = [
    {
        key: "open1",
        question: "What does the QMS module in LIMS manage?",
        answer: `It manages audits, CAPAs, deviations, change controls, and ensures compliance with quality standards.`,
    },
    {
        key: "open2",
        question: "Can QMS workflows be customized?",
        answer: `Yes, QMS workflows can be configured as per your SOPs and internal quality procedures.`,
    },
    {
        key: "open3",
        question: "How are deviations handled in QMS?",
        answer: `Deviations can be logged, investigated, and escalated to CAPA with complete tracking and documentation.`,
    },
    {
        key: "open4",
        question: "Does QMS support risk assessment?",
        answer: `Yes, risk assessment tools can be integrated to evaluate and prioritize issues based on severity and impact.`,
    },
    {
        key: "open5",
        question: "Can we assign tasks and get reminders through QMS?",
        answer: `Yes, task assignments, due dates, and email reminders are part of QMS automation.`,
    }
];

const faqs_dms = [
    {
        key: "open1",
        question: "What is managed in the DMS?",
        answer: `SOPs, specifications, manuals, reports, and other quality documents are securely managed in DMS.`,
    },
    {
        key: "open2",
        question: "Can DMS handle document versioning and approvals?",
        answer: `Yes, version control, electronic approvals, and workflow routing are built-in features.`,
    },
    {
        key: "open3",
        question: "Is there access control for sensitive documents?",
        answer: `Yes, role-based permissions ensure only authorized users can access or edit documents.`,
    },
    {
        key: "open4",
        question: "Does DMS support electronic signatures?",
        answer: `Yes, compliant with 21 CFR Part 11, DMS supports electronic signatures with full audit trails.`,
    },
    {
        key: "open5",
        question: "Can we link documents from DMS to QMS or ADBS modules?",
        answer: `Absolutely. Documents can be linked to batches, CAPAs, deviations, or test methods for traceability.`,
    }
];

const faqs_adbs = [
    {
        key: "open1",
        question: "What is Lab Iconics ADBS?",
        answer: `It's an automated software solution that regularly backs up your important data to ensure it's safe from loss, corruption, or system failures.`,
    },
    {
        key: "open2",
        question: "Where is the backup data stored?",
        answer: `You can store backups on external hard drives, NAS devices, or secure cloud storage — depending on your setup.`,
    },
    {
        key: "open3",
        question: "Is my data secure with ADBS?",
        answer: `Yes, ADBS uses robust encryption to protect your data during both transfer and storage.`,
    },
    {
        key: "open4",
        question: "Can I recover my data after a system crash?",
        answer: `Absolutely. ADBS includes disaster recovery features to restore your data to the same or a different system, even a virtual machine.`,
    },
    {
        key: "open5",
        question: "Does it support automatic scheduling?",
        answer: `Yes, you can schedule backups daily, weekly, or monthly — completely automated with zero manual effort.`,
    }
];

const faqs_lims_eln = [
    {
        key: "open1",
        question: "What are the benefits of integrating LIMS and ELN?",
        answer: `It unifies sample management and experimental documentation, eliminating duplication, reducing errors, and streamlining lab workflows.`,
    },
    {
        key: "open2",
        question: "Is the system compliant with regulatory standards?",
        answer: `Yes, it fully supports 21 CFR Part 11, GLP, and other global regulations with audit trails, e-signatures, and version control.`,
    },
    {
        key: "open3",
        question: "Can the platform capture data directly from lab instruments?",
        answer: `Absolutely. It integrates with lab instruments to automatically capture and log data in both LIMS and ELN modules.`,
    },
    {
        key: "open4",
        question: "Can I customize the system for both QC and R&D needs?",
        answer: `Yes, it’s highly configurable to support distinct workflows for Quality Control, Research & Development, and other lab functions.`,
    },
    {
        key: "open5",
        question: "Is full traceability ensured from sample login to COA release?",
        answer: `Yes, every step — from sample registration to final reporting — is tracked with complete traceability and audit readiness.`,
    }
];

const faqs_tlims = [
    {
        key: "open1",
        question: "What types of labs is T-LIMS suitable for?",
        answer: `T-LIMS is designed for pharmaceutical, food, environmental, and industrial testing labs, offering compliance with standards like FDA, WHO-GMP, FSSAI, ISO 17025, and NABL.`,
    },
    {
        key: "open2",
        question: "Can T-LIMS generate regulatory-compliant Certificates of Analysis (CoAs)?",
        answer: `Yes. T-LIMS supports fast, customizable, and fully compliant CoA generation, complete with electronic signatures for audit-readiness.`,
    },
    {
        key: "open3",
        question: "How does T-LIMS help in maintaining data integrity?",
        answer: `All test data, approvals, and documents are stored in a centralized repository with full audit trails and secure e-signatures, ensuring data integrity and traceability.`,
    },
    {
        key: "open4",
        question: "Is T-LIMS cloud-based and accessible remotely?",
        answer: `Absolutely. T-LIMS is cloud-based with role-based access controls, enabling secure access from anywhere and centralized management across lab locations.`,
    },
    {
        key: "open5",
        question: "What kind of automation does T-LIMS offer?",
        answer: `T-LIMS automates workflows such as sample registration, test scheduling, analyst task tracking, inventory management boosting efficiency and accuracy.`,
    }
];

const faqs_saas = [
    {
        key: "open1",
        question: "What makes the Lab Iconics LIMS-ELN SaaS model cost-effective?",
        answer: `Lab Iconics uses a cloud-based, pay-as-you-go SaaS model that eliminates the need for costly IT infrastructure, expensive upgrades, and long deployment cycles—offering enterprise-grade features at a budget-friendly price.`,
    },
    {
        key: "open2",
        question: "How quickly can we go live with Lab Iconics SaaS LIMS-ELN?",
        answer: `The system is pre-configured and fully validated, allowing labs to go live in under 48 hours. You simply upload your metadata, and the solution is ready to use—fast, efficient, and hassle-free.`,
    },
    {
        key: "open3",
        question: "How does the Lab Iconics SaaS LIMS-ELN ensure data security and regulatory compliance?",
        answer: `With features like end-to-end encryption, secure access controls, tamper-proof audit trails, and compliance with ISO 17025 and 21 CFR Part 11, the platform guarantees data integrity, confidentiality, and audit readiness.`,
    },
    {
        key: "open4",
        question: "Can this system support remote access and collaboration across multiple lab sites?",
        answer: `Yes, Lab Iconics LIMS-ELN provides secure, anytime-anywhere access and enables real-time collaboration across locations, promoting teamwork and seamless workflow management.`,
    },
    {
        key: "open5",
        question: "How does Lab Iconics LIMS-ELN improve lab efficiency and productivity?",
        answer: `By streamlining sample tracking, automating workflows, and optimizing data management, the system reduces errors, accelerates turnaround time, and boosts overall lab productivity.`,
    }
];

const faqs_lms = [
    {
        key: "open1",
        question: "Is Lab Iconics LMS only for pharmaceutical companies?",
        answer: `No. Lab Iconics LMS is a general enterprise Learning Management System flexible for organizations across all industries—including Healthcare, Manufacturing, Tech, Education, and Corporate—while possessing specialized strengths in pharma and regulatory compliance.`,
    },
    {
        key: "open2",
        question: "How does LMS handle role-based training and learning paths?",
        answer: `You can configure training requirements based on job role, department, location, experience, or competencies. Employees receive automated learning paths that guide them step-by-step from induction to advanced certifications.`,
    },
    {
        key: "open3",
        question: "Does the system support assessments, quizzes, and automatic grading?",
        answer: `Yes, Lab Iconics LMS supports question banks, multiple-choice, true/false, and multi-answer questions with configurable passing scores, multiple attempt rules, and instant automated evaluation.`,
    },
    {
        key: "open4",
        question: "How does LMS support regulatory compliance and certification renewals?",
        answer: `The platform tracks issue dates, expiry dates, and mandatory retraining requirements. Automated reminders notify employees and managers ahead of certification expirations, maintaining full audit trails for compliance.`,
    },
    {
        key: "open5",
        question: "Can multi-site or multi-organization structures be managed in one platform?",
        answer: `Yes, Lab Iconics LMS supports multi-tenant and multi-site organizational hierarchies (Organization → Business Unit → Location → Department → Team → Employee) with centralized management and localized access controls.`,
    }
];

const faqs_elog = [
    {
        key: "open1",
        question: "What is an E-Logbook?",
        answer: `An Electronic Logbook is a digital system used to replace or manage traditional paper-based logbooks. It allows organizations to record activities electronically while providing controlled workflows, traceability, review, approval, and historical access.`,
    },
    {
        key: "open2",
        question: "What types of logbooks can be digitized?",
        answer: `A wide range of operational logbooks can be digitized, including equipment, cleaning, maintenance, environmental monitoring, area checks, shift handover, calibration, utilities, and other organization-specific activities.`,
    },
    {
        key: "open3",
        question: "Can we configure our own logbook formats?",
        answer: `Yes. Logbook templates, fields, activities, workflows, permissions, and approval requirements can be configured based on the organization's processes.`,
    },
    {
        key: "open4",
        question: "Does E-Logbook support electronic signatures?",
        answer: `The platform can support electronic signature workflows for applicable review and approval activities, based on the configured process and organizational requirements.`,
    },
    {
        key: "open5",
        question: "Does it maintain an audit trail?",
        answer: `The system can maintain traceable histories of applicable user actions and record activities, helping authorized users understand the history of electronic records.`,
    },
    {
        key: "open6",
        question: "Can multiple departments use the same E-Logbook platform?",
        answer: `Yes. Organizations can configure different logbooks, roles, workflows, and permissions for different departments, sites, areas, and activities.`,
    },
    {
        key: "open7",
        question: "Can E-Logbook integrate with LIMS?",
        answer: `Yes. E-Logbook can be positioned as part of an integrated laboratory information ecosystem and can support integration with LIMS and other enterprise applications based on the required architecture.`,
    },
    {
        key: "open8",
        question: "Can we migrate existing paper logbooks?",
        answer: `Existing paper-based processes can be analyzed and converted into appropriate digital templates and workflows. Migration requirements depend on the type and volume of historical records.`,
    },
    {
        key: "open9",
        question: "Is E-Logbook suitable for regulated environments?",
        answer: `E-Logbook is designed for use in environments where controlled electronic records, traceability, review, approval, and data-integrity practices are important. Regulatory suitability depends on the implementation, configuration, validation, procedures, and applicable requirements of the organization.`,
    },
    {
        key: "open10",
        question: "Can E-Logbook be deployed across multiple sites?",
        answer: `Yes. The platform can be designed to support multi-site environments, with appropriate site-level configuration, access control, and operational workflows.`,
    }
];

const faqs_ipqc = [
    {
        key: "open1",
        question: "What is IPQC?",
        answer: `IPQC stands for In-Process Quality Control. It involves performing quality checks during manufacturing to ensure that products and processes remain within predefined quality requirements.`,
    },
    {
        key: "open2",
        question: "Why is IPQC important?",
        answer: `IPQC helps identify quality issues during production rather than waiting until the final product stage. Early detection can reduce deviations, rework, waste, and potential batch failures.`,
    },
    {
        key: "open3",
        question: "What can be managed using Lab Iconics IPQC?",
        answer: `Lab Iconics IPQC can manage batch-wise and stage-wise testing, test parameters, specifications, result entry, evaluations, reviews, approvals, history, and quality reporting.`,
    },
    {
        key: "open4",
        question: "Can IPQC be managed batch-wise?",
        answer: `Yes. Quality activities can be associated with production batches, allowing users to track tests and results throughout the batch lifecycle.`,
    },
    {
        key: "open5",
        question: "Can users view stage-wise quality history?",
        answer: `Yes. Lab Iconics provides stage-wise history to help users understand the quality activities and results associated with each manufacturing stage.`,
    },
    {
        key: "open6",
        question: "Does IPQC support review and approval?",
        answer: `Yes. Configurable review and approval workflows can be used to ensure that quality results are reviewed and approved by authorized users.`,
    },
    {
        key: "open7",
        question: "Does IPQC provide traceability?",
        answer: `Yes. Quality activities can be traced through batch, stage, test, result, user, timestamp, review, and approval information.`,
    },
    {
        key: "open8",
        question: "How does IPQC connect with laboratory and floor instruments?",
        answer: `Lab Iconics IPQC features Instrument Management and direct result fetching using the Lab Iconics Connector middleware. Test results (e.g. balance weights, hardness, thickness, friability) are automatically pushed from instruments directly into batch testing records without manual data entry.`,
    }
];

const faqs_vms = [
    {
        key: "open1",
        question: "What is Lab Iconics VMS?",
        answer: `Lab Iconics VMS (Validation Management System) is an intelligent, AI-powered validation automation platform designed to manage, automate, and execute validation activities across the entire Lab Iconics product ecosystem.`,
    },
    {
        key: "open2",
        question: "Which applications can be validated using VMS?",
        answer: `VMS validates the complete Lab Iconics ecosystem, including LIMS, ELN, IPQC, E-Logbook, Support Portals, Instrument Connectivity, Batch/Sample Management, REST APIs, and database integrations.`,
    },
    {
        key: "open3",
        question: "What does 'One-Click Validation Execution' mean?",
        answer: `With one-click execution, users select a validation suite and click execute. VMS automatically initializes environments, runs predefined test scenarios, asserts UI/API/DB results, captures evidence, logs deviations, and compiles validation reports automatically.`,
    },
    {
        key: "open4",
        question: "How does AI enhance validation in VMS?",
        answer: `AI is integrated throughout the validation lifecycle to generate test cases from requirements, optimize regression suites, analyze expected vs actual results, triage failure root causes, and provide a natural-language AI Validation Assistant.`,
    },
    {
        key: "open5",
        question: "Does VMS support automated evidence collection?",
        answer: `Yes. VMS automatically captures and stores time-stamped screenshots, execution logs, API payloads, database validation states, and user audit trails associated with every execution.`,
    },
    {
        key: "open6",
        question: "Can VMS validate end-to-end workflows across multiple connected products?",
        answer: `Yes. VMS executes cross-product scenarios such as Instrument → Connectivity → LIMS → IPQC → Review → QA Approval → COA Generation to validate complete business workflows rather than isolated silos.`,
    },
    {
        key: "open7",
        question: "How does VMS handle change impact analysis?",
        answer: `When a release, patch, or config change occurs, VMS analyzes the change footprint and automatically recommends which modules, APIs, database tables, and regression test cases must be revalidated.`,
    },
    {
        key: "open8",
        question: "Can VMS auto-generate validation documentation?",
        answer: `Yes. VMS assists in generating Validation Plans, Protocols, Requirements Traceability Matrices (RTM), Test Execution Reports, Deviation Summaries, and Validation Summary Reports.`,
    }
];